export const KEYBOARD_TYPE = 'QWERTY';
export const MAX_TIME_BEFORE_OBJECT_NOTIFICATION = 20;


// WEBPACK FOOTER //
// src/constants/Settings.js